var _circle, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfReflectionSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0335,
    cy: 47.0336,
    r: 25,
    transform: "rotate(-23.7106 39.0335 47.0336)",
    fill: "#FFD100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5934 53.3322C52.1635 52.3532 52.4619 51.2742 53.2596 50.9239C54.0573 50.5736 55.0538 51.0838 55.4837 52.0628C55.9137 53.0417 55.6152 54.1207 54.8175 54.4711C54.0198 54.8214 53.0234 54.3112 52.5934 53.3322Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1862 56.5532C45.7266 55.5067 46.0583 54.3477 46.9267 53.9663C47.795 53.585 48.8729 54.1249 49.3325 55.1714C49.7921 56.2179 49.4604 57.3769 48.592 57.7583C47.7237 58.1397 46.6458 57.5997 46.1862 56.5532Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78L89 78",
    stroke: "#93969B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_19408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.423 70.8152L62.1594 77.21C62.1527 77.4433 62.1981 77.675 62.2925 77.8884C62.3868 78.1018 62.5276 78.2914 62.7046 78.4434C62.8816 78.5954 63.0903 78.706 63.3155 78.767C63.5407 78.828 63.7767 78.8379 64.0062 78.7961C64.1152 78.7875 64.2229 78.7671 64.3275 78.7354L70.224 76.1526L79.8347 62.1288L71.9861 56.7849L62.423 70.8152Z",
    fill: "#FFCBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2925 77.8885C62.1982 77.6751 62.1527 77.4433 62.1594 77.2101L62.2256 75.6063L66.2613 77.8885L64.3276 78.7355C64.223 78.7672 64.1153 78.7875 64.0063 78.7961C63.7768 78.838 63.5408 78.828 63.3156 78.767C63.0904 78.706 62.8817 78.5955 62.7047 78.4435C62.5277 78.2915 62.3869 78.1019 62.2925 77.8885Z",
    fill: "#93969B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8356 62.129L70.2248 76.1528L69.7534 74.3002C69.7252 74.1894 69.6254 74.1118 69.5111 74.1118L67.6743 74.1118C67.5362 74.1118 67.4243 73.9999 67.4243 73.8618L67.4243 72.0988C67.4243 71.9538 67.3015 71.8393 67.1569 71.8494L65.1877 71.9869C65.0765 71.9947 64.9737 71.9279 64.9355 71.8233L64.4606 70.5229C64.4164 70.4021 64.2878 70.3344 64.1633 70.3666L62.4238 70.8154L71.987 56.785L79.8356 62.129Z",
    fill: "#FF7700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4412 55.5234L77.2009 51.9468C76.8567 51.7131 76.4339 51.6252 76.0251 51.7023C75.6162 51.7795 75.2546 52.0154 75.0191 52.3584L73.0308 55.2716L80.8734 60.6244L82.8617 57.7112C82.9779 57.54 83.0593 57.3476 83.101 57.1449C83.1428 56.9422 83.1442 56.7333 83.1051 56.5301C83.0661 56.3269 82.9873 56.1334 82.8734 55.9606C82.7595 55.7879 82.6126 55.6393 82.4412 55.5234Z",
    fill: "#F2F4F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_19408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3735,
    height: 27.3735,
    fill: "white",
    transform: "translate(56 54.0752) rotate(-10.6853)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfReflectionSkills);
export default __webpack_public_path__ + "static/media/self_reflection_skills.717f229cea1363ffac929165f19d9149.svg";
export { ForwardRef as ReactComponent };